<div class="container">
  <app-lesgroep-info-sidebar [details]="details$ | async" [medewerkers$]="medewerkers$" class="sidebar"></app-lesgroep-info-sidebar>
  <div class="grafiek">
    <app-lesgroep-detail-leermiddel-gebruik-grafiek [model]="grafiekdata$ | async" [totenmet]="totenmet$ | async" [vanaf]="vanaf$ | async"></app-lesgroep-detail-leermiddel-gebruik-grafiek>
  </div>
  <div class="tabel">
    <app-lesgroep-detail-leermiddel-gebruik-tabel *ngFor="let leermiddel of tabeldata$ | async" [tabeldata]="leermiddel"></app-lesgroep-detail-leermiddel-gebruik-tabel>
  </div>
</div>
